import { getUnifyVersion } from '@csp/csp-common-unify-version';
import { StorageService } from '@csp/web-storage';

export const storedUnifyVersionMatches = (): boolean => {
  const storedUnifyReleaseVersion = StorageService.localStorage.getItem('unify-release-version');
  const currentUnifyReleaseVersion = getUnifyVersion();

  return storedUnifyReleaseVersion === currentUnifyReleaseVersion;
};
